import Vue from 'vue'
import Vuex from 'vuex'
import scorm from '@shared/utils/scormHandler'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    stepIndex: 0,
    steps: ['intro', 'sigleQuizz', 'quizzOutro', 'gapFill1', 'gapFill2'],
    quizzScore: 0,
    gapFillFinished: false
  },
  getters: {
    currentStep (state) {
      return state.steps[state.stepIndex]
    },
    progress (state) {
      return state.stepIndex / (state.steps.length - 1) * 100
    },
    status (state, getters) {
      return getters.progress === 100 && state.gapFillFinished ? 'passed' : 'incomplete'
    },
    quizzStatus (state) {
      if (state.quizzScore >= 8) {
        return 'success'
      } else if (state.quizzScore >= 5) {
        return 'normal'
      } else {
        return 'fail'
      }
    }
  },
  mutations: {
    loadState (state, datas) {
      state.stepIndex = datas.stepIndex
      state.quizzScore = datas.quizzScore
    },
    nextStep (state) {
      state.stepIndex++
    },
    setCardGameScore (state, score) {
      state.cardGameScore = score
    },
    navigateTo (state, index) {
      state.stepIndex = index
    },
    setQuizzScore (state, score) {
      state.quizzScore = score
    },
    setGapFillFinished (state, status) {
      state.gapFillFinished = status
    }
  },
  actions: {
    next ({ state, dispatch, commit }) {
      if (state.stepIndex === state.steps.length - 1) {
        dispatch('exit')
      } else {
        commit('nextStep')
      }
    },
    navigate ({ state, commit }, stepName) {
      commit('navigateTo', state.steps.indexOf(stepName))
    },
    init ({ dispatch }) {
      scorm.initLMSConnection()
      dispatch('load')
    },
    save ({ state, getters }) {
      scorm.setDatasToLMS({
        stepIndex: state.stepIndex,
        quizzScore: state.quizzScore
      })
      scorm.writeProgressToLMS(getters.progress, getters.status)
      try {
        scorm.commitToLMS()
      } catch (e) {
        if (process.env.NODE_ENV === 'production') {
          console.log('SCORM api error : ' + e)
        }
      }
    },
    load ({ commit }) {
      if (scorm.getDatasFromLMS()) {
        commit('loadState', scorm.getDatasFromLMS())
      }
    },
    exit ({ dispatch }) {
      dispatch('save')
      scorm.exitLMSConnection()
    }
  }
})
